import { registerMutation, registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import { multiAccountHttpClient } from 'multi-account-http-client';
const BASE_URL = 'multi-account/copy-manager/v1';
const BASE_V3_URL = 'multi-account/copy-manager/v3';
const BULK_ASSET_TO_PORTABLE_KEY_URL = `${BASE_URL}/key-convertor/bulk/asset-to-portable-key`;
const ASYNC_TASK_URL = `${BASE_URL}/tasks/copy-assets/async`;
export const getBulkAssetPortableKeysFieldName = 'portableKeys';
export const GET_PORTABLE_KEYS = registerQuery({
  fieldName: getBulkAssetPortableKeysFieldName,
  args: ['assetIds', 'portableType'],
  fetcher: ({
    assetIds,
    portableType
  }) => {
    return http.post(BULK_ASSET_TO_PORTABLE_KEY_URL, {
      data: {
        assetIds,
        portableType
      }
    });
  }
});
export const createSyncTaskFieldName = 'syncTask';
export const createSyncTaskFieldNameV3 = 'syncTaskV3';
export const CREATE_ASSET_SYNC_TASK = registerMutation({
  fieldName: createSyncTaskFieldName,
  args: ['command', 'fromHubId', 'portableKeys', 'assetNames', 'portableType', 'toHubId'],
  fetcher: ({
    command,
    fromHubId,
    portableKeys,
    assetNames,
    portableType,
    toHubId
  }) => {
    const taskData = Object.assign({
      type: portableType
    }, command === 'DIFF' && assetNames ? {
      assetNames
    } : {}, (command !== 'DIFF' || !assetNames) && portableKeys ? {
      portableKeys
    } : {});
    return http.post(ASYNC_TASK_URL, {
      data: {
        toHubId,
        fromHubId,
        command,
        tasks: [taskData],
        forceTypes: false,
        clientType: 'MULTI_ACCOUNT',
        syncOptions: {
          skipComponentValidation: false,
          skipLimitValidation: false
        }
      }
    });
  }
});
export const CREATE_ASSET_SYNC_TASK_V3 = registerMutation({
  fieldName: createSyncTaskFieldNameV3,
  args: ['command', 'fromHubId', 'portableKeys', 'assetNames', 'portableType', 'toHubId'],
  fetcher: ({
    command,
    fromHubId,
    portableKeys,
    assetNames,
    portableType,
    toHubId
  }) => {
    const taskData = Object.assign({
      type: portableType
    }, command === 'DIFF' && assetNames ? {
      assetNames
    } : {}, (command !== 'DIFF' || !assetNames) && portableKeys ? {
      portableKeys
    } : {});
    const reqUrl = command === 'DIFF' ? `${BASE_V3_URL}/diffs` : `${BASE_V3_URL}/sync`;
    return multiAccountHttpClient.post(reqUrl, {
      data: {
        toHubId,
        fromHubId,
        command,
        tasks: [taskData],
        forceTypes: false,
        clientType: 'MULTI_ACCOUNT',
        syncOptions: {
          skipComponentValidation: false,
          skipLimitValidation: false
        }
      },
      destinationHubId: Number(toHubId)
    });
  }
});
export const getTaskStatusFieldName = 'taskStatus';
export const GET_TASK_STATUS = registerQuery({
  fieldName: getTaskStatusFieldName,
  args: ['taskId'],
  fetcher: ({
    taskId
  }) => {
    return http.get(`portability-sync/v1/tasks/${taskId}`);
  }
});
export const getTaskStatusV2FieldName = 'taskStatusV2';
export const GET_TASK_STATUS_V2 = registerQuery({
  fieldName: getTaskStatusV2FieldName,
  args: ['taskId', 'targetHubId'],
  fetcher: ({
    taskId,
    targetHubId
  }) => {
    return http.get(`multi-account/copy-manager/v2/tasks/${taskId}/diffs/status?targetPortalId=${targetHubId}`);
  }
});
export const getAssetDetailsFieldName = 'assetDetails';
export const GET_ASSET_DETAILS = registerQuery({
  fieldName: getAssetDetailsFieldName,
  args: ['taskId', 'destinationHubId'],
  fetcher: ({
    taskId,
    destinationHubId
  }) => {
    return multiAccountHttpClient.get(`${BASE_V3_URL}/diffs/${taskId}/summary`, {
      destinationHubId,
      timeout: 60000 * 5
    });
  }
});